import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { textMObj } = typographyStyles;

export const supportChatCss: CSSObject = {
  background: ui.core[25],
  borderRadius: "8px",
  padding: "16px",
  gap: "10px",
  display: "flex",
};

export const supportChatIconCss: CSSObject = {
  background: "white",
  padding: "12px",
  borderRadius: "28px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "fit-content",
};

export const supportChatMessageCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  gap: "4px",
};

export const supportHelpTextCss: CSSObject = {
  ...textMObj,
  color: ui.neutral[600],
  "& button": {
    textDecoration: "underline",
  },
  "& a": {
    padding: 0,
    marginLeft: "4px",
  },
};

export const supportHoursTextCss: CSSObject = {
  ...textMObj,
  color: ui.neutral[500],
};
